export default __webpack_public_path__ + "static/media/horasactividad.49ac490e.png";